import Component from "./InputTextArea";
import * as sources from "./components";

export interface IInputTextAreaExtensions {
    Label: typeof sources.Label;
    Left: typeof sources.Left;
    LeftAddon: typeof sources.LeftAddon;
    Right: typeof sources.Right;
    Hint: typeof sources.Hint;
    Bottom: typeof sources.Bottom;
}

export const InputTextArea: typeof Component & IInputTextAreaExtensions =
    Object.assign(Component, sources);

export type { InputTextAreaProps } from "./types";
